import { connect } from 'react-redux';
import HeaderTitle from 'header/components/title';

const mapStateToProps = (state) => {
  return {
    title: "Build a memorable visual brand",
  };
};

export default connect(mapStateToProps)(HeaderTitle);
